//deps
import React, { memo } from "react";

//widgets
import { PaymentProgressLoader } from "@payment-ui/widgets/payment-progress-loader";

//styles
import { MovingTray, MovingTrayContainer } from "./styles/TurboPaymentPreloader.style";

import { TURBO_PAYMENT_WIDGET_DATA_TEST_IDS } from "@swiggy-private/payment-test-ids";

function TurboPaymentPreloader() {
    return (
        <>
            <PaymentProgressLoader hideMovingTray />
            <MovingTrayContainer data-testid={TURBO_PAYMENT_WIDGET_DATA_TEST_IDS.MOVING_TRAY_CONTAINER}>
                <MovingTray data-testid={TURBO_PAYMENT_WIDGET_DATA_TEST_IDS.MOVING_TRAY} />
            </MovingTrayContainer>
        </>
    );
}

export default memo(TurboPaymentPreloader);
